import MaterialGrid from "../../../../../__snowpack__/pkg/@mui/material/Grid.js";
import styled from "styled-components";
export const MergeUnitsEditPageContainer = styled.div.withConfig({
  displayName: "merge-units-edit-pagestyles__MergeUnitsEditPageContainer",
  componentId: "sc-8bsdnp-0"
})(["& >:first-child{", "}"], {
  marginBottom: "2rem"
});
export const UnitListGridContainer = styled(MaterialGrid).withConfig({
  displayName: "merge-units-edit-pagestyles__UnitListGridContainer",
  componentId: "sc-8bsdnp-1"
})(["grid-template-rows:1fr auto;grid-template-columns:repeat(3,1fr);"]);
